export const constant = {
	selector: {
		target: 'js-info-bar',
		filter: 'js-filter',
	},
}
